import { clearWebAdminLocalSession } from './clearWebAdminLocalSession';
import { signOut } from '@/services/session';

export { clearWebAdminLocalSession } from './clearWebAdminLocalSession';

/**
 * Полный выход: локальные флаги сессии, затем отзыв refresh-токена на сервере.
 * Редирект на /login делает SessionGate, когда сессия становится unauthenticated.
 */
export async function logoutWebAdmin(): Promise<void> {
  clearWebAdminLocalSession();
  await signOut();
}
